import { render } from "./ItemLabels.vue?vue&type=template&id=99ae747a&scoped=true"
import script from "./ItemLabels.vue?vue&type=script&lang=js"
export * from "./ItemLabels.vue?vue&type=script&lang=js"

import "./ItemLabels.vue?vue&type=style&index=0&id=99ae747a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ae747a"]])

export default __exports__